export class PayableCitationModel
{
    public citationKey: string;
    public citationNumber: string;
    public description: string;
    public amount: number;
    public amountPaid: number;
    public amountDue: number;
    public issuedDate: Date;
    public plate: string;
    public plateRegion: string;
    public statusId: number;
    public statusName: string;
    public routerLink: any[];
    public entitySourceId: number = 23;
}